import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	wrapperNote: {
		id: 'personal-settings-preference-fields.notification-preferences-options-wrapper.wrapper-note',
		defaultMessage: 'Receive emails when:',
		description:
			'Label for the wrapper which houses 3 checkboxes for notification preferences, 2 for role based and 1 for activity',
	},
	emailFormatNote: {
		id: 'personal-settings-preference-fields.notification-preferences-options-wrapper.email-format-note',
		defaultMessage: 'How do you like your emails?',
		description:
			'Note for the email format radio group, user can select between HTML and plain text emails',
	},
	emailFormatHeading: {
		id: 'personal-settings-preference-fields.notification-preferences-options-wrapper.email-format-heading',
		defaultMessage: 'Email format',
		description: 'Heading for the email format section',
	},
});
